/**
 * Parallel coordinate transformations for parallel coordinate.
 */
export const Parallel = () => [['parallel', 0, 1, 0, 1]];
Parallel.props = {};
//# sourceMappingURL=parallel.js.map